// Generated by pnpm --filter @langfuse/icons generate. Do not edit.
import { createIcon } from "../../create-icon.js";
import { Calendar as RawCalendar } from "lucide-react";
export const Calendar = /* @__PURE__ */ createIcon(RawCalendar, "Calendar", 2);
